import React from 'react';
import { OrderNumber } from './OrderNumber';
import { OrderOpened } from './OrderOpened';
import { SplitClosing } from './SplitClosing';
import { Services } from './Services';
import { PropertyValue } from './PropertyValue';
import { LoanAmount } from './LoanAmount';
import { LoanNumber } from './LoanNumber';
import { OrderType } from './orderType/OrderType';
import { BorrowerAppointments } from './BorrowerAppointments';
import { SellerAppointments } from './SellerAppointments';
import { ClosingDate } from './closingDate/ClosingDate';
import { EstimatedClosingDate } from './EstimatedClosingDate';
import { FundingDate } from './FundingDate';
import { RateLockExpiration } from './RateLockExpiration';
import { TransactionID } from './TransactionID';
import { OrderAssociationSummaryItemContainer } from './orderAssociation/OrderAssociationSummaryItemContainer';
import { VestedOwners } from './VestedOwners';
import { RelocationEmployer } from './RelocationEmployer';
import { EMDAmount } from './emdAmount/EMDAmount';

export const OrderDataTab: React.FC = () => {
  return (
    <>
      <OrderNumber />
      <OrderOpened />
      <SplitClosing />
      <Services />
      <PropertyValue />
      <LoanAmount />
      <LoanNumber />
      <EMDAmount />
      <OrderType />
      <RelocationEmployer />
      <BorrowerAppointments />
      <SellerAppointments />
      <ClosingDate />
      <EstimatedClosingDate />
      <FundingDate />
      <RateLockExpiration />
      <TransactionID />
      <OrderAssociationSummaryItemContainer />
      <VestedOwners />
    </>
  );
};
